import React from 'react';
import { Card } from 'src/modules/shared/components/atoms/cards';
import { CardBody } from 'src/modules/shared/components/atoms/cards/card-body';
import { Text } from 'src/modules/shared/components/atoms/text';
import type { ReactNode } from 'react';
import { PiCaretRight } from 'react-icons/pi';

interface IntegrationIndexCardProps {
  title: string;
  description: string;
  icon: ReactNode;
  badges?: ReactNode;
  onClick: () => void;
}

export const IntegrationIndexCard: React.FC<IntegrationIndexCardProps> = ({
  title,
  description,
  icon,
  badges,
  onClick,
}) => {
  return (
    <Card
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          onClick();
        }
      }}
      variant="primary"
      appearance="outline"
      shadow="sm"
      className="h-full min-h-[132px] w-full text-left transition-all hover:border-primary-200 hover:shadow-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500"
    >
      <CardBody className="flex h-full items-start gap-4 p-4">
        <div className="shrink-0">{icon}</div>
        <div className="min-w-0 flex-1">
          <div className="flex items-center gap-2 flex-wrap">
            <Text size="h6" weight="medium">
              {title}
            </Text>
            {badges ? <div className="min-w-0">{badges}</div> : null}
          </div>
          <Text
            size="small"
            color="secondary"
            className="mt-1 min-h-10 line-clamp-2"
          >
            {description}
          </Text>
        </div>
        <div className="shrink-0 self-center text-secondary-400">
          <PiCaretRight className="h-5 w-5" />
        </div>
      </CardBody>
    </Card>
  );
};
